import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'base_numeric_simple_reversed',
    dependencies: ['levels_maths/base_numeric_simple']
})


function common (q, params) {
    q.addText('Base' + params.base + '(?) = ' + params.x)
    q.answer = parseInt((params.x).toString(params.base), 10)
}


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 9, {name: 'base'})
        common(q, {
            base,
            x:    random.fairChoiceInt(0, base - 1, {name: 'x'})
        })
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 9, {name: 'base'})
        common(q, {
            base,
            x:    base
        })
    }
})

level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 9, {name: 'base'})
        common(q, {
            base,
            x:    base + random.fairChoiceInt(0, 1, {name: 'x'})
        })
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 9, {name: 'base'})
        common(q, {
            base,
            x:    base + random.fairChoiceInt(2, base - 1, {name: 'x'})
        })
    },
    times: 2
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 9, {name: 'base'})
        common(q, {
            base,
            x:    base * 2
        })
    }
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 8, {name: 'base'})
        common(q, {
            base,
            x:    (base * 2) + random.fairChoiceInt(1, base - 1, {name: 'x'})
        })
    }
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(4, 8, {name: 'base'})
        common(q, {
            base,
            x:    base * 3
        })
    }
})


level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(4, 7, {name: 'base'})
        common(q, {
            base,
            x:    (base * 3) + random.fairChoiceInt(1, base - 1, {name: 'x'})
        })
    }
})





export default level
